export default (formComponent) => {
  return formComponent.components[formComponent.components.length - 1]
}
